/** 本から TODO を作るフォーマットの API サービス */

import { apiClient } from '@/api/client'
import type { TodoBookTemplate, TodoBookTemplateInput } from '@/api/types/todo-book-template'

const BASE = '/todo-book-templates'

export const listTodoBookTemplates = async (): Promise<TodoBookTemplate[]> => {
  const res = await apiClient.get(BASE)
  return res.data
}

export const createTodoBookTemplate = async (body: TodoBookTemplateInput): Promise<TodoBookTemplate> => {
  const res = await apiClient.post(BASE, body)
  return res.data
}

export const updateTodoBookTemplate = async (
  id: number,
  body: Partial<TodoBookTemplateInput>,
): Promise<TodoBookTemplate> => {
  const res = await apiClient.patch(`${BASE}/${id}`, body)
  return res.data
}

export const deleteTodoBookTemplate = async (id: number): Promise<void> => {
  await apiClient.delete(`${BASE}/${id}`)
}

/** ids は自分のフォーマット全件を並べたい順に渡す */
export const reorderTodoBookTemplates = async (ids: number[]): Promise<TodoBookTemplate[]> => {
  const res = await apiClient.put(`${BASE}/order`, { ids })
  return res.data
}
